import { render } from "./index.vue?vue&type=template&id=77b41074"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-banners/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77b41074"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77b41074', __exports__)) {
    api.reload('77b41074', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=77b41074", () => {
    api.rerender('77b41074', render)
  })

}


export default __exports__